import { Box, Typography } from "@material-ui/core";
import * as React from "react";
import { useRecoilValue } from "recoil";

import { CustomButton } from "@/components/Button";
import { PropertyEditLayout as BaseTemplate } from "@/components/property_edit/PropertyEditLayout";
import { SelectedProperty } from "@/view_models/propertySelectors";

import { LeaseContractHistoryEditor } from "./HistoryEdit";
import { LeaseContractHistoryItem } from "./HistoryItem";

interface props {
  onClickPageBack: () => void;
}

export const EditPropertySectionLeaseContractHistory: React.FC<props> = ({ onClickPageBack }) => {
  // 選択済み物件取得
  const selected_property = useRecoilValue(SelectedProperty);
  const [isShowNewHistory, setIsShowNewHistory] = React.useState(false);

  const handleAddNewHistory = () => {
    setIsShowNewHistory(true);
  };

  const handleOnCreate = () => {
    setIsShowNewHistory(false);
  };

  // 最新の契約（最初の1件）と過去の契約（2件目以降）を分離
  const sortedContracts =
    selected_property?.lease_contracts
      ?.slice()
      .sort((a, b) => new Date(b.starts_at).getTime() - new Date(a.starts_at).getTime()) || [];
  const latestContract = sortedContracts[0];
  const pastContracts = sortedContracts.slice(1);

  if (isShowNewHistory)
    return (
      <BaseTemplate headerTitle="契約の追加" onBack={() => setIsShowNewHistory(false)}>
        <LeaseContractHistoryEditor onCancel={() => setIsShowNewHistory(false)} onCreate={handleOnCreate} />
      </BaseTemplate>
    );
  return (
    <BaseTemplate headerTitle="賃貸契約情報" onBack={onClickPageBack} isBackGroundWhite>
      <Typography component="h3" data-edit-section>
        現在の契約
      </Typography>
      {latestContract && <LeaseContractHistoryItem key={latestContract.id} leaseContract={latestContract} current />}
      <Box mt={2} mb={4}>
        <CustomButton type="button" buttonSize="L" fullWidth onClick={handleAddNewHistory}>
          次の契約を追加
        </CustomButton>
      </Box>
      {pastContracts.length > 0 && (
        <>
          <Typography component="h3" data-edit-section>
            過去の契約
          </Typography>
          {pastContracts.map((contract) => (
            <LeaseContractHistoryItem key={contract.id} leaseContract={contract} />
          ))}
        </>
      )}
    </BaseTemplate>
  );
};
